var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKp = function SvgKp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 0a11.972 11.972 0 0 0-9.097 4.174h18.194A11.972 11.972 0 0 0 12 0ZM21.096 19.827H2.903A11.973 11.973 0 0 0 12 24.001c3.637 0 6.896-1.619 9.096-4.174Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M22.239 5.739H1.76A11.943 11.943 0 0 0 0 11.999c0 2.295.644 4.439 1.761 6.261H22.24A11.943 11.943 0 0 0 24 12c0-2.295-.644-4.439-1.761-6.261Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M7.383 16.618a4.617 4.617 0 1 0 0-9.234 4.617 4.617 0 0 0 0 9.234Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m7.383 7.383 1.036 3.189h3.358l-2.718 1.97 1.044 3.199-2.72-1.98-2.717 1.976 1.04-3.194-2.715-1.971h3.356l1.036-3.189Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgKp;